import { HTTP_METHODS } from '../../constants/HttpConstants';
import { sendRequestToDoSelectCentralService } from '../../utils/request';

export const tryAsRecruiterApi = async (slug: string) =>
  sendRequestToDoSelectCentralService({
    method: HTTP_METHODS.POST,
    url: `/rpc/test.try_as_recruiter`,
    params: {
      slug,
    },
  });
